import Head from '../../layouts/Head';
import Blog2Container from '../../containers/Blog2';
import Footer from '../../layouts/Footer';

const Blog2 = () => {

  return (
    <>
		<Head Title='Blog2' />
		<Blog2Container />
		<Footer />
    </>
  );
}

export default Blog2;

